export default "__VITE_ASSET__BNcebf9H__"